import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import styles from './Login.module.css';
import { Button } from '#/components/Button';
import { useAuth } from '#/utils/auth/useAuth';
import { LINKS } from '#/constants';

const N_SCHOOL_LOGO = `${import.meta.env.VITE_ASSETS_URL}/assets/images/n_school_logo.png`;
const OPEN_IN_NEW_ICON = `${import.meta.env.VITE_ASSETS_URL}/assets/images/open_in_new.svg`;

export function Login() {
  const navigate = useNavigate();
  const { login, isLoading, isAuthenticated } = useAuth();

  // 認証済みでトップに来た場合は結果画面へ送る。
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/result');
    }
  }, [isLoading, isAuthenticated, navigate]);

  return (
    <div className={styles.card}>
      <img className={styles.logo} src={N_SCHOOL_LOGO} alt="N高等学校のロゴ" />
      <h1 className={styles.title}>{'N高グループ向け\nZEN ID ログイン確認'}</h1>
      <p className={styles.description}>
        あなたのZEN IDが生徒用アカウントとして正しく設定され、利用可能な状態かを確認できます。
      </p>
      <Button variant="primary" onClick={() => void login()}>
        ZEN ID でログインして確認する
      </Button>
      <a className={styles.trouble} href={LINKS.technicalSupport} target="_blank" rel="noopener noreferrer">
        ログインでお困りの方はこちら
        <img className={styles.troubleIcon} src={OPEN_IN_NEW_ICON} alt="" />
      </a>
      <p className={styles.troubleSub}>（N高グループ テクニカルサポートサイト）</p>
    </div>
  );
}
